import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficeAgentMonthSchedule = (jy, jm, monthDays, agent_id) => {
  return http.get(
    `${getBaseUrl()}/back_office_agent_month_schedule/${jy}/${jm}/${monthDays}/${agent_id}`,
  );
};

export const submitBackOfficeSchedule = data => {

  return http.post(
    `${getBaseUrl()}/back_office_schedule`,
    data
  );
};

export const updateBackOfficeSchedule = data => {

  return http.put(
    `${getBaseUrl()}/back_office_schedule/${data.id}`,
    data
  );
};